module.exports = __webpack_public_path__ + "img/banner_2026.59ad7f5b.png";